import type { PropsWithChildren } from 'react';

import { ButtonGroupButton } from './components/ButtonGroupButton'
import { ButtonGroupStyled } from './styles/ButtonGroupStyled'

export interface IButtonGroupProps {}

export const ButtonGroup = ({
  children,
}: PropsWithChildren<IButtonGroupProps>) => {
  return <ButtonGroupStyled>{children}</ButtonGroupStyled>
}

ButtonGroup.Button = ButtonGroupButton
